export enum CheckinState {
  CLOSED = 'CLOSED',
  COMPLETED = 'COMPLETED',
  DISABLED = 'DISABLED',
  HEALTH_CHECK_COMPLETED = 'HEALTH_CHECK_COMPLETED',
  HEALTH_CHECK_OPEN = 'HEALTH_CHECK_OPEN',
  OPEN = 'OPEN',
  PENDING = 'PENDING',
  UNASSIGNED = 'UNASSIGNED',
}
